import React from "react";

interface TeamCardProps {
  name: string;
  title: string;
  description: string;
  imageUrl: string;
  nameColor?: string; // Optional class for custom name color
}

const TeamCard: React.FC<TeamCardProps> = ({
  name,
  title,
  description,
  imageUrl,
  nameColor = "text-gray-900", // default color
}) => {
  return (
    <div className="bg-white p-2 hover:shadow-lg transition text-left rounded-xl">
      <img
        src={imageUrl}
        alt={name}
        className="w-full h-[400px] md:h-[250px] object-cover object-top rounded-lg"
      />
      <h3 className={`text-lg mt-3 font-semibold ${nameColor}`}>{name}</h3>
      <p className="text-sm text-gray-600">{title}</p>
      <p className="mt-2 text-sm text-[#777]">{description}</p>
    </div>
  );
};

export default TeamCard;
